/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import withIsomorphicRenderer from '@tcp/core/src/components/common/hoc/withIsomorphicRenderer';
import { toastMessageInfo } from '@tcp/core/src/components/common/atoms/Toast/container/Toast.actions';
import { PropTypes } from 'prop-types';
import { getDefaultStore } from '@tcp/core/src/components/features/account/User/container/User.selectors';
import {
  getAPIConfigForAdobe,
  getSessionDataForAdobe,
  getUserState,
} from '@tcp/core/src/adobeAnalytics/adobe.selectors';
import {
  getSelectedAccessories,
  getSecondarySelectedAccessories,
} from '@tcp/core/src/components/common/molecules/Accessories/container/Accessories.selectors';
import logger from '@tcp/core/src/utils/loggerInstance';
import {
  clearGrandParentDataAction,
  clearAllSelectedAccessories,
} from '@tcp/core/src/components/common/molecules/Accessories/container/Accessories.actions';
import { getFavoriteStore } from '@tcp/core/src/components/common/organisms/PickupStoreModal/container/PickUpStoreModal.selectors';
import { getCurrencyAttributes } from '@tcp/core/src/reduxStore/selectors/currency.selectors';
import pushEventToAdobeAnalytics from '@tcp/core/src/adobeAnalytics/adobe.utils';
import {
  getModalState,
  getUniqueId,
} from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.selectors';
import { clearRecommendationData } from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.actions';
import OutfitProductSkeleton from '../molecules/OutfitProductSkeleton';
import {
  openQuickViewWithValues,
  setQuickViewProductImage,
  setItemDataForQuickView,
} from '../../../../common/organisms/QuickViewModal/container/QuickViewModal.actions';
import OutfitDetails from '../views/index';
import { trackPageView, setClickAnalyticsData, trackClick } from '../../../../../analytics/actions';
import {
  getOutfitImage,
  getOutfitProducts,
  getAddedToBagErrorCatId,
  getUnavailableCount,
  getLoadingState,
  getOnModelImageAbTestOutfitPdp,
  getIsOutfitAddedCTAEnabled,
  getShowAddedToBagCTA,
  getOutfitDetailFormValues,
  getOutfitId,
  getSelectedProductList,
  getOutfitCache,
  getEntireFormValue,
  getCurrentOutfit,
  getSelectedProductId,
} from './OutfitDetails.selectors';
import {
  getOutfitDetails,
  resetOutfitDetails,
  initActions,
  setSelectedOutfitProductList,
  setOutfitPage,
  resetOutfitCacheData,
} from './OutfitDetails.actions';
import { getPDPTopPromos } from '../../ProductDetail/container/ProductDetail.selectors';
import { isCanada } from '../../../../../utils';
import {
  isPlccUser,
  getUserLoggedInState,
  isRememberedUser,
} from '../../../account/User/container/User.selectors';
import {
  getIsInternationalShipping,
  getCurrentCurrency,
  getIsKeepAliveProduct,
  getIsDynamicBadgeEnabled,
  getMultiPackThreshold,
  getIsNewReDesignEnabled,
  getIsAccessoryEnabled,
  getIsHideOriginalPriceAndMarchantTagEnabled,
  getBundleOutfitInfluencerHandleAbTest,
  getOutfitDetailsPageRedesign,
  getIsOutfitNewDesignEnabled,
  getIsBuyMorePromoEnabled,
  getIsGuestFavAppEnabled,
  getIsUpdatedPromotionsDisplayEnabled,
} from '../../../../../reduxStore/selectors/session.selectors';
import { getExternalCampaignFired } from '../../ProductListing/container/ProductListing.selectors';
import { getIsPickupModalOpen } from '../../../../common/organisms/PickupStoreModal/container/PickUpStoreModal.selectors';
import { getCartItemInfo } from '../../../CnC/AddedToBag/util/utility';
import {
  addToCartEcomNewDesign,
  addToCartEcom,
  addMultipleItemsToCartEcom,
  addMultipleItemsToCartEcomNew,
  clearAddToBagErrorState,
  addToBagPayloadTotalCount,
} from '../../../CnC/AddedToBag/container/AddedToBag.actions';
import {
  getAddedToBagError,
  getMultipleItemsAddedToBagError,
} from '../../../CnC/AddedToBag/container/AddedToBag.selectors';
import getAddedToBagFormValues from '../../../../../reduxStore/selectors/form.selectors';
import { OUTFIT_LISTING_FORM } from '../../../../../constants/reducer.constants';
import {
  removeAddToFavoriteErrorState,
  addItemsToWishlist,
  setLastDeletedItemIdAction,
  showToastModal,
  setShowLoginModal,
} from '../../Favorites/container/Favorites.actions';
import {
  fetchAddToFavoriteErrorMsg,
  selectActiveWishList,
  wishListFromState,
  getDefaultFavItemInProgressFlag,
  fetchErrorMessages,
  getToastModalState,
  getShowLoginModal,
} from '../../Favorites/container/Favorites.selectors';
import { setExternalCampaignState } from '../../../../common/molecules/Loader/container/Loader.actions';
import {
  getStyliticsProductTabListSelector,
  getCTLImageABTest,
} from '../../../../common/molecules/ModuleQ/container/ModuleQ.selector';
import getLoadData from '../util';
import OutfitDetailsNew from '../views/OutfitDetailNew.view';
import { getInYourBagProducts } from '../../BundleProduct/container/BundleProduct.selectors';
import { getInYourBagProductCount } from '../../BundleProduct/container/BundleProduct.actions';
import { styliticsProductTabListDataReq } from '../../../../common/organisms/StyliticsProductTabList/container/StyliticsProductTabList.actions';
import {
  getPromotionsData,
  getServerTimeFromState,
} from '../../../../common/organisms/Promotions/container/Promotions.selectors';

const getOutfitIDFromPath = () => {
  if (typeof window !== 'undefined') {
    const idArr = window.location?.pathname.split('/');
    return [idArr[3], idArr[4]];
  }
  return [];
};
/* eslint-disable max-len */
class OutfitDetailsContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      outfitIdLocal: '',
    };
  }

  static pageProps = {
    pageData: {
      pageName: 'outfit',
    },
  };

  componentDidMount() {
    const { User, APIConfig, session } = this.props;
    const pageData = {
      pageName: 'outfit detail page',
      pageSection: 'outfit',
      pageSubSection: '',
      pageSubSection2: '',
      pageType: 'outfit page',
    };
    pushEventToAdobeAnalytics('page_view', { pageData, User, APIConfig, session });
  }

  static getInitialProps = async ({ props, query, isServer, apiConfig }) => {
    const { getOutfit } = props;

    let vendorColorProductIdsList;
    let outfitId;
    if (isServer) {
      ({ vendorColorProductIdsList, outfitId } = query);
    } else {
      ({
        router: {
          query: { vendorColorProductIdsList, outfitId },
        },
      } = props);
      if (!outfitId) {
        logger.info('OutfitId not received from router query');
        [outfitId, vendorColorProductIdsList] = getOutfitIDFromPath();
      }
    }
    await getOutfit({ outfitId, vendorColorProductIdsList, fromOutFitPage: true, apiConfig });
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      router: {
        query: { outfitId: selectedOutfitId },
      },
    } = nextProps;
    return selectedOutfitId ? { ...prevState, outfitIdLocal: selectedOutfitId } : { ...prevState };
  }

  componentWillUnmount() {
    const {
      resetOutFitProductState,
      isAccessoriesEnabled,
      clearGrandParentAccessoryData,
      clearSelectedAccessoriesAction,
    } = this.props;
    resetOutFitProductState();
    if (isAccessoriesEnabled) {
      clearGrandParentAccessoryData();
      clearSelectedAccessoriesAction();
    }
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  getCartInfo = (addToBagEcom, productInfo, generalProductId, currentState, isSBP) => {
    const { isEnabledOutfitAddedCTA, priceCurrency } = this.props;
    const {
      newPartNumber: multipackProduct,
      partIdDetail: partIdInfo,
      multiPackCount,
      getMultiPackAllColor: getAllMultiPack,
      getNewMultiPackAllColor: getAllNewMultiPack,
      selectedMultipack,
      listPrice,
      ratings,
      reviewsCount,
      ratingsProductId,
      isFromNewOutfitExperience,
    } = productInfo;

    // RWD-16438 Fix: Same form name is removed if user go from outfit to PDP and then press back button.
    const formName = `${OUTFIT_LISTING_FORM}-${generalProductId}`;
    const formValues = getAddedToBagFormValues(currentState, formName);
    let cartItemInfo = getCartItemInfo(productInfo, formValues);
    cartItemInfo = {
      ...cartItemInfo,
      skipAddToBagModal: isEnabledOutfitAddedCTA,
      multipackProduct,
      multiPackCount,
      getAllMultiPack,
      getAllNewMultiPack,
      selectedMultipack,
      partIdInfo,
      selectedCategoryId: '',
      listPrice,
      ratings,
      reviewsCount,
      ratingsProductId,
      fromPage: '',
      outfitId: '',
      selectedProductId: '',
      viaModule: '',
      brand: '',
      title: '',
      priceCurrency,
      isFromNewOutfitExperience,
    };
    cartItemInfo.addedFromSBP = isSBP;
    return cartItemInfo;
  };

  markIncludedAccessory = (accessories, isMandatoryCustomization) => {
    let accessoriesArr = [];
    if (accessories) {
      accessoriesArr = accessories.map((accessory, i) => {
        return {
          ...accessory,
          c_priceIncluded: isMandatoryCustomization && i === 0,
        };
      });
    }
    return accessoriesArr;
  };

  handleAddToBag = (addToBagEcom, productInfo, generalProductId, currentState, isSBP = false) => {
    const { isAccessoriesEnabled, selectedAccessories, secondarySelectedAccessoryList } =
      this.props;
    const cartItemInfo = this.getCartInfo(
      addToBagEcom,
      productInfo,
      generalProductId,
      currentState,
      isSBP
    );
    if (isAccessoriesEnabled && productInfo.accessoriesData) {
      const productInfoAccessoryData = productInfo?.accessoriesData?.customizationType || '';
      const isMandatoryCustomization = productInfoAccessoryData === 'mandatory';
      cartItemInfo.outfitCustomType = productInfoAccessoryData;

      if (productInfo?.accessoriesData?.accessoriesProductID?.length) {
        cartItemInfo.accessories = [
          ...this.markIncludedAccessory(selectedAccessories, isMandatoryCustomization),
          ...this.markIncludedAccessory(secondarySelectedAccessoryList, true),
        ];
      }
    }
    cartItemInfo.primaryBrand = productInfo && productInfo.primaryBrand;

    addToBagEcom(cartItemInfo);
  };

  handleMultipleAddToBag = (
    addMultipleToBagEcom,
    productList,
    currentState,
    isSBP = false,
    navigation,
    route
  ) => {
    if (productList.length === 1) {
      const { outfitProduct } = productList[0];
      const { generalProductId } = outfitProduct;
      const { addToBagEcom } = this.props;
      outfitProduct.isFromNewOutfitExperience = !!route?.params?.isFromNewOutfitExperience;
      this.handleAddToBag(addToBagEcom, outfitProduct, generalProductId, currentState);
      return;
    }
    const productItemsInfo = productList.map((productInfo) => {
      const { outfitProduct } = productInfo;
      const { generalProductId } = outfitProduct;
      const primaryBrand = outfitProduct && outfitProduct.primaryBrand;
      const cartItemInfo = this.getCartInfo(
        addMultipleToBagEcom,
        outfitProduct,
        generalProductId,
        currentState,
        isSBP
      );
      cartItemInfo.primaryBrand = primaryBrand;
      return cartItemInfo;
    });
    addMultipleToBagEcom({ productItemsInfo });
  };

  checkInWishlist = (wishList, productId) =>
    wishList && wishList[productId] && wishList[productId].isInDefaultWishlist;

  render() {
    const {
      outfitImageUrl,
      unavailableCount,
      outfitProducts,
      isPlcc,
      isInternationalShipping,
      priceCurrency,
      currencyAttributes,
      addToBagEcom,
      addToFavorites,
      currentState,
      addToBagError,
      addToBagErrorId,
      multipleAddToBagError,
      isPickupModalOpen,
      isLoggedIn,
      navigation,
      toastMessage,
      AddToFavoriteErrorMsg,
      removeAddToFavoritesErrorMsg,
      topPromos,
      isKeepAliveEnabled,
      isLoading,
      trackPageLoad,
      isOnModelAbTestOutfitPdp,
      storeId,
      router: { asPath: asPathVal, query: { viaModule, viaPage } } = {},
      isEnabledOutfitAddedCTA,
      showAddedToBagCta,
      isDynamicBadgeEnabled,
      multiPackThreshold,
      selectActiveWishListFromState,
      defaultWishListFromState,
      onSetLastDeletedItemIdAction,
      deleteFavItemInProgressFlag,
      errorMessages,
      completeFormValues,
      trackWishListClick,
      route,
      isHideOriginalPriceAndMarchantTagEnabled,
      isOutfitsRedesign,
      currentOutfit,
      inYourBagProducts,
      getInYourBagData,
      setIsOutfitPage,
      styliticsProductTabList,
      onQuickViewOpenClick,
      selectedOutfitId,
      showToastModalAction,
      toastModalState,
      ...otherProps
    } = this.props;

    const { outfitIdLocal } = this.state;
    const displayOutfitPDP = !isLoading && outfitProducts;

    const wishList = defaultWishListFromState;

    const multiErrorMessage = multipleAddToBagError && multipleAddToBagError.errMsg;
    return (
      <React.Fragment>
        {displayOutfitPDP && !isOutfitsRedesign ? (
          <OutfitDetails
            outfitImageUrl={outfitImageUrl}
            unavailableCount={unavailableCount}
            outfitProducts={outfitProducts}
            isCanada={isCanada()}
            isPlcc={isPlcc}
            isInternationalShipping={isInternationalShipping}
            currencySymbol={priceCurrency}
            currencyAttributes={currencyAttributes}
            handleAddToBag={this.handleAddToBag}
            handleMultipleAddToBag={this.handleMultipleAddToBag}
            addToBagEcom={addToBagEcom}
            currentState={currentState}
            addToBagError={addToBagError}
            addToBagErrorId={addToBagErrorId}
            multipleAddToBagError={multiErrorMessage}
            isPickupModalOpen={isPickupModalOpen}
            addToFavorites={addToFavorites}
            isLoggedIn={isLoggedIn}
            navigation={navigation}
            outfitId={outfitIdLocal}
            toastMessage={toastMessage}
            AddToFavoriteErrorMsg={AddToFavoriteErrorMsg}
            removeAddToFavoritesErrorMsg={removeAddToFavoritesErrorMsg}
            asPathVal={asPathVal}
            topPromos={topPromos}
            isKeepAliveEnabled={isKeepAliveEnabled}
            trackPageLoad={trackPageLoad}
            isOnModelAbTestOutfitPdp={isOnModelAbTestOutfitPdp}
            storeId={storeId}
            viaModule={viaModule}
            viaPage={viaPage}
            isEnabledOutfitAddedCTA={isEnabledOutfitAddedCTA}
            showAddedToBagCta={showAddedToBagCta}
            isDynamicBadgeEnabled={isDynamicBadgeEnabled}
            isLoading={isLoading}
            {...otherProps}
            multiPackThreshold={multiPackThreshold}
            defaultWishListFromState={wishList}
            onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
            isOutfitPage
            checkInWishlist={this.checkInWishlist}
            wishList={defaultWishListFromState}
            deleteFavItemInProgressFlag={deleteFavItemInProgressFlag}
            errorMessages={errorMessages}
            completeFormValues={completeFormValues}
            trackWishListClick={trackWishListClick}
            route={route}
            isHideOriginalPriceAndMarchantTagEnabled={isHideOriginalPriceAndMarchantTagEnabled}
            styliticsProductTabList={styliticsProductTabList}
            onQuickViewOpenClick={onQuickViewOpenClick}
            showToastModalAction={showToastModalAction}
            toastModalState={toastModalState}
          />
        ) : (
          currentOutfit && (
            <OutfitDetailsNew
              currentOutfit={currentOutfit}
              inYourBagProducts={inYourBagProducts}
              handleAddToBag={this.handleAddToBag}
              getInYourBagData={getInYourBagData}
              setIsOutfitPage={setIsOutfitPage}
              styliticsProductTabList={styliticsProductTabList}
              navigation={navigation}
              outfitImageUrl={outfitImageUrl}
              unavailableCount={unavailableCount}
              outfitProducts={outfitProducts}
              isCanada={isCanada()}
              isPlcc={isPlcc}
              isInternationalShipping={isInternationalShipping}
              currencySymbol={priceCurrency}
              currencyAttributes={currencyAttributes}
              handleMultipleAddToBag={this.handleMultipleAddToBag}
              addToBagEcom={addToBagEcom}
              currentState={currentState}
              addToBagError={addToBagError}
              addToBagErrorId={addToBagErrorId}
              multipleAddToBagError={multiErrorMessage}
              isPickupModalOpen={isPickupModalOpen}
              addToFavorites={addToFavorites}
              isLoggedIn={isLoggedIn}
              outfitId={outfitIdLocal}
              toastMessage={toastMessage}
              AddToFavoriteErrorMsg={AddToFavoriteErrorMsg}
              removeAddToFavoritesErrorMsg={removeAddToFavoritesErrorMsg}
              asPathVal={asPathVal}
              topPromos={topPromos}
              isKeepAliveEnabled={isKeepAliveEnabled}
              trackPageLoad={trackPageLoad}
              isOnModelAbTestOutfitPdp={isOnModelAbTestOutfitPdp}
              storeId={storeId}
              viaModule={viaModule}
              viaPage={viaPage}
              isEnabledOutfitAddedCTA={isEnabledOutfitAddedCTA}
              showAddedToBagCta={showAddedToBagCta}
              isDynamicBadgeEnabled={isDynamicBadgeEnabled}
              isLoading={isLoading}
              {...otherProps}
              multiPackThreshold={multiPackThreshold}
              defaultWishListFromState={wishList}
              onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
              isOutfitPage
              checkInWishlist={this.checkInWishlist}
              wishList={defaultWishListFromState}
              deleteFavItemInProgressFlag={deleteFavItemInProgressFlag}
              errorMessages={errorMessages}
              completeFormValues={completeFormValues}
              trackWishListClick={trackWishListClick}
              route={route}
              isHideOriginalPriceAndMarchantTagEnabled={isHideOriginalPriceAndMarchantTagEnabled}
              onQuickViewOpenClick={onQuickViewOpenClick}
              selectedOutfitId={selectedOutfitId}
            />
          )
        )}
        {isLoading || !displayOutfitPDP ? (
          <OutfitProductSkeleton
            isOutfitsRedesign={isOutfitsRedesign}
            styliticsProductTabList={styliticsProductTabList}
            selectedOutfitId={selectedOutfitId}
            outfitIdLocal={outfitIdLocal}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

OutfitDetailsContainer.pageInfo = {
  pageId: 'outfit',
  pageData: {
    pageName: 'outfit',
    pageSection: 'outfit',
    pageSubSection: 'outfit',
    loadAnalyticsOnload: false,
  },
};

OutfitDetailsContainer.getInitActions = () => initActions;

const mapStateToProps = (state) => {
  const stateProps = {
    outfitImageUrl: getOutfitImage(state),
    isLoading: getLoadingState(state),
    unavailableCount: getUnavailableCount(state),
    outfitProducts: getOutfitProducts(state),
    outfitItemId: getOutfitId(state),
    isCanada: isCanada(),
    isPlcc: isPlccUser(state),
    isInternationalShipping: getIsInternationalShipping(state),
    priceCurrency: getCurrentCurrency(state),
    currencyAttributes: getCurrencyAttributes(state),
    addToBagError: getAddedToBagError(state),
    addToBagErrorId: getAddedToBagErrorCatId(state),
    multipleAddToBagError: getMultipleItemsAddedToBagError(state),
    currentState: state,
    isPickupModalOpen: getIsPickupModalOpen(state),
    isLoggedIn: getUserLoggedInState(state) && !isRememberedUser(state),
    AddToFavoriteErrorMsg: fetchAddToFavoriteErrorMsg(state),
    topPromos: getPDPTopPromos(state),
    isKeepAliveEnabled: getIsKeepAliveProduct(state),
    isOnModelAbTestOutfitPdp: getOnModelImageAbTestOutfitPdp(state),
    storeId: getDefaultStore(state) || getFavoriteStore(state),
    isEnabledOutfitAddedCTA: !isCanada() && getIsOutfitAddedCTAEnabled(state),
    showAddedToBagCta: getShowAddedToBagCTA(state),
    isExternalCampaignFired: getExternalCampaignFired(state),
    isDynamicBadgeEnabled: getIsDynamicBadgeEnabled(state),
    styliticsProductTabList: getStyliticsProductTabListSelector(state),
    showSmallImage: getCTLImageABTest(state),
    multiPackThreshold: getMultiPackThreshold(state),
    selectedOutfitProducts: getSelectedProductList(state),
    outfitCache: getOutfitCache(state),
    defaultWishListFromState: wishListFromState(state),
    selectActiveWishListFromState: selectActiveWishList(state),
    deleteFavItemInProgressFlag: getDefaultFavItemInProgressFlag(state),
    errorMessages: fetchErrorMessages(state),
    completeFormValues: getEntireFormValue(state),
    isNewReDesign: getIsNewReDesignEnabled(state),
    secondarySelectedAccessories: getSecondarySelectedAccessories(state),
    selectedAccessories: getSelectedAccessories(state),
    isAccessoriesEnabled: getIsAccessoryEnabled(state),
    isHideOriginalPriceAndMarchantTagEnabled: getIsHideOriginalPriceAndMarchantTagEnabled(state),
    isBundleOutfitInfluencerHandleEnabled: getBundleOutfitInfluencerHandleAbTest(state),
    User: getUserState(state),
    APIConfig: getAPIConfigForAdobe(state),
    session: getSessionDataForAdobe(state),
    isOutfitsRedesign: getOutfitDetailsPageRedesign(state),
    currentOutfit: getCurrentOutfit(state),
    inYourBagProducts: getInYourBagProducts(state),
    selectedOutfitId: getSelectedProductId(state),
    getIsOutfitNewDesignEnabled: getIsOutfitNewDesignEnabled(state),
    quickViewProductId: getUniqueId(state),
    isQVModalOpen: getModalState(state),
    promotionsData: getPromotionsData(state),
    isBuyMorePromoEnabled: getIsBuyMorePromoEnabled(state),
    serverTime: getServerTimeFromState(state),
    toastModalState: getToastModalState(state),
    isGuestFavAppEnabled: getIsGuestFavAppEnabled(state),
    showLoginModal: getShowLoginModal(state),
    isUpdatedPromotionsDisplayEnabled: getIsUpdatedPromotionsDisplayEnabled(state),
  };

  stateProps.formValues = getOutfitDetailFormValues(state);

  return stateProps;
};

function mapDispatchToProps(dispatch) {
  return {
    getOutfit: (payload) => {
      dispatch(getOutfitDetails(payload));
    },
    addToBagEcom: (payload) => {
      dispatch(addToCartEcom(payload));
    },
    addToBagEcomNew: (payload) => {
      dispatch(addToCartEcomNewDesign(payload));
    },
    clearAddToBagError: () => {
      dispatch(clearAddToBagErrorState());
    },
    addToFavorites: (payload) => {
      dispatch(addItemsToWishlist(payload));
    },
    toastMessage: (payload) => {
      dispatch(toastMessageInfo(payload));
    },
    removeAddToFavoritesErrorMsg: (payload) => {
      dispatch(removeAddToFavoriteErrorState(payload));
    },
    resetOutFitProductState: () => {
      dispatch(resetOutfitDetails());
    },
    setExternalCampaignFired: (payload) => {
      dispatch(setExternalCampaignState(payload));
    },
    trackPageLoad: (payload) => {
      const { eventSetData, loadData } = getLoadData(payload);
      dispatch(setClickAnalyticsData(eventSetData));
      const dispatchTimer = setTimeout(() => {
        dispatch(trackPageView(loadData));
        const analyticsTimer = setTimeout(() => {
          dispatch(setClickAnalyticsData({}));
          clearTimeout(analyticsTimer);
        }, 200);
        clearTimeout(dispatchTimer);
      }, 100);
    },
    trackViewAction: (data) => {
      dispatch(trackPageView(data));
    },
    setClickAnalyticsDataAction: (data) => {
      dispatch(setClickAnalyticsData(data));
    },
    setSelectedOutfitProduct: (payload) => {
      dispatch(setSelectedOutfitProductList(payload));
    },
    addMultipleToBagEcom: (payload) => {
      dispatch(addMultipleItemsToCartEcom(payload));
    },
    addMultipleToBagEcomNew: (payload) => {
      dispatch(addMultipleItemsToCartEcomNew(payload));
    },
    onSetLastDeletedItemIdAction: (payload) => {
      dispatch(setLastDeletedItemIdAction(payload));
    },
    trackWishListClick: (payload) => {
      dispatch(setClickAnalyticsData(payload));
      dispatch(trackClick());
    },
    addToBagPayloadTotalCountAction: (payload) => {
      dispatch(addToBagPayloadTotalCount(payload));
    },
    clearGrandParentAccessoryData: () => {
      dispatch(clearGrandParentDataAction());
    },
    clearSelectedAccessoriesAction: () => {
      dispatch(clearAllSelectedAccessories());
    },
    getInYourBagData: (payload) => {
      dispatch(getInYourBagProductCount(payload));
    },
    setIsOutfitPage: (payload) => {
      dispatch(setOutfitPage(payload));
    },
    onQuickViewOpenClick: (payload) => {
      const { image, productInfo } = payload;
      dispatch(setQuickViewProductImage(image));
      dispatch(setItemDataForQuickView(productInfo));
      dispatch(openQuickViewWithValues(payload));
    },
    getStyliticsProductTabListData: (payload) => {
      dispatch(styliticsProductTabListDataReq(payload));
    },
    showToastModalAction: (payload) => {
      dispatch(showToastModal(payload));
    },
    dispatchResetOutfitCacheData: (payload) => {
      dispatch(resetOutfitCacheData(payload));
    },
    clearRecommendationDataForOutfit: (payload) => {
      dispatch(clearRecommendationData(payload));
    },
    toggleLoginModal: (payload) => {
      dispatch(setShowLoginModal(payload));
    },
  };
}

OutfitDetailsContainer.propTypes = {
  outfitImageUrl: PropTypes.string,
  unavailableCount: PropTypes.number,
  outfitProducts: PropTypes.shape({}),
  router: PropTypes.shape({
    query: PropTypes.shape({}),
  }),
  isPlcc: PropTypes.bool,
  isInternationalShipping: PropTypes.bool,
  priceCurrency: PropTypes.string,
  currencyAttributes: PropTypes.shape({}),
  addToBagEcom: PropTypes.func.isRequired,
  currentState: PropTypes.shape({}).isRequired,
  navigation: PropTypes.shape({}),
  addToBagError: PropTypes.string,
  addToBagErrorId: PropTypes.string,
  isPickupModalOpen: PropTypes.bool,
  addToFavorites: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool,
  toastMessage: PropTypes.func,
  AddToFavoriteErrorMsg: PropTypes.string,
  removeAddToFavoritesErrorMsg: PropTypes.func,
  isKeepAliveEnabled: PropTypes.bool,
  trackPageLoad: PropTypes.func,
  topPromos: PropTypes.string,
  isLoading: PropTypes.bool,
  isOnModelAbTestOutfitPdp: PropTypes.bool,
  resetOutFitProductState: PropTypes.func,
  storeId: PropTypes.string,
  isEnabledOutfitAddedCTA: PropTypes.bool,
  showAddedToBagCta: PropTypes.string,
  isDynamicBadgeEnabled: PropTypes.shape({}),
  multiPackThreshold: PropTypes.string,
  selectActiveWishListFromState: PropTypes.shape([]),
  defaultWishListFromState: PropTypes.shape({}),
  onSetLastDeletedItemIdAction: PropTypes.func,
  deleteFavItemInProgressFlag: PropTypes.bool,
  errorMessages: PropTypes.shape({}),
  completeFormValues: PropTypes.shape({}),
  multipleAddToBagError: PropTypes.string,
  isNewReDesign: PropTypes.bool,
  addToBagEcomNew: PropTypes.func.isRequired,
  isHideOriginalPriceAndMarchantTagEnabled: PropTypes.bool,
  isBundleOutfitInfluencerHandleEnabled: PropTypes.bool,
  toastModalState: PropTypes.shape({
    duration: PropTypes.number,
    showToast: PropTypes.bool,
  }),
  showToastModalAction: PropTypes.func,
  User: PropTypes.shape({}),
  APIConfig: PropTypes.shape({}),
  session: PropTypes.shape({}),
  isUpdatedPromotionsDisplayEnabled: PropTypes.bool,
};

OutfitDetailsContainer.defaultProps = {
  outfitImageUrl: '',
  unavailableCount: 0,
  outfitProducts: null,
  router: {
    query: {},
  },
  navigation: {},
  resetOutFitProductState: () => {},
  isPlcc: false,
  isInternationalShipping: false,
  priceCurrency: 'USD',
  currencyAttributes: { exchangevalue: 1 },
  addToBagError: '',
  addToBagErrorId: '',
  isPickupModalOpen: false,
  isLoggedIn: false,
  trackPageLoad: () => {},
  toastMessage: () => {},
  AddToFavoriteErrorMsg: '',
  removeAddToFavoritesErrorMsg: () => {},
  isKeepAliveEnabled: false,
  topPromos: '',
  isLoading: false,
  isOnModelAbTestOutfitPdp: false,
  storeId: '',
  isEnabledOutfitAddedCTA: false,
  showAddedToBagCta: '',
  isDynamicBadgeEnabled: false,
  multiPackThreshold: '',
  selectActiveWishListFromState: [],
  defaultWishListFromState: {},
  onSetLastDeletedItemIdAction: () => {},
  deleteFavItemInProgressFlag: false,
  errorMessages: {},
  completeFormValues: {},
  multipleAddToBagError: '',
  isNewReDesign: false,
  isHideOriginalPriceAndMarchantTagEnabled: false,
  isBundleOutfitInfluencerHandleEnabled: false,
  toastModalState: {
    duration: 0,
    showToast: false,
  },
  showToastModalAction: () => {},
  User: {},
  APIConfig: {},
  session: {},
  isUpdatedPromotionsDisplayEnabled: false,
};

export default withIsomorphicRenderer({
  WrappedComponent: OutfitDetailsContainer,
  mapStateToProps,
  mapDispatchToProps,
});
